import { Utilities } from "../../../utils/utilities";
import { CompanyData } from "../Company/CompanyData";
import { ReadAccess } from "../General/AccessData";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { TranslationData } from "../General/TranslationData";
import { Role } from "../User/Role";

export type CollectionConnections = {
  tasks: boolean;
  routines: boolean;
  files: boolean;
};

export class CollectionData extends FirebaseData {
  name: TranslationData = new TranslationData();
  archived: boolean = false;
  companies: CompanyData[] = [];
  roles: Role[] = [];

  previewFields: string[] = [];
  customFieldsOrder: string[] = [];

  connections: CollectionConnections = { tasks: true, routines: true, files: true };
  readAccess: ReadAccess = {};
  requiredWriteAccess: ReadAccess | undefined = undefined;

  setup(data: any) {
    this.name.setup(data.name);
    this.archived = typeof data.archived === "boolean" ? data.archived : false;

    this.companies = Array.isArray(data.companies) ? data.companies.map((c: any) => LocalData.companies.addData("" + c)) : [];
    this.roles = Array.isArray(data.roles) ? data.roles.map((r: any) => Role.getRoleWithId(parseInt(r))) : [];

    this.previewFields = Array.isArray(data.previewFields) ? data.previewFields.filter((field: any) => typeof field === "string") : [];
    this.customFieldsOrder = Array.isArray(data.customFieldsOrder) ? data.customFieldsOrder : [];

    this.connections = { tasks: true, routines: true, files: true };
    if (typeof data.connections === "object") {
      this.connections = {
        tasks: typeof data.connections.tasks === "boolean" ? data.connections.tasks : true,
        routines: typeof data.connections.routines === "boolean" ? data.connections.routines : true,
        files: typeof data.connections.files === "boolean" ? data.connections.files : true,
      };
    }

    this.readAccess = Utilities.getReadAccess(data.readAccess);
    this.requiredWriteAccess = Utilities.getOptionalReadAccess(data.requiredWriteAccess);

    super.setup(data);
  }
}

